import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAOiyTJ-Eko4u3I9Gem3BkgBbxZkaf0560",
    authDomain: "news-95e44.firebaseapp.com",
    projectId: "news-95e44",
    storageBucket: "news-95e44.firebasestorage.app",
    messagingSenderId: "572405492859",
    appId: "1:572405492859:web:a5fcda387edd59cf0fc6de",
    measurementId: "G-8J456922CL"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Initialize Functions with EU region
const functions = getFunctions(app, "europe-west1");

// Google Auth Provider
const googleProvider = new GoogleAuthProvider();

export { app, analytics, db, functions, auth, googleProvider };